import Vue from "vue";
import Vuex from "vuex";
import { rooms } from "@/store/modules/rooms";
import { events } from "@/store/modules/events";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    rooms,
    events
  }
});
